import { LayoutContainer } from '@petsmart-ui/sparky';
import type { CampaignHeroProps } from './types';
import './CampaignHero.scss';

import CampaignHeroFullWidth from './CampaignHeroFullWidth';
import CampaignHeroMd from './CampaignHeroMd';
import CampaignHeroSplit from './CampaignHeroSplit';

const CampaignHeroComponent = {
    'Full Width': CampaignHeroFullWidth,
    Split: CampaignHeroSplit,
    Md: CampaignHeroMd,
};

export default function CampaignHero(props: CampaignHeroProps) {
    const Component = CampaignHeroComponent[props.variant];

    return (
        <LayoutContainer className="campaign-hero-container">
            <Component {...props} />
        </LayoutContainer>
    );
}
